// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"IconButton_wrapper__xYRCS"};